<template>
  <div class="dustcont">
    <div class="top">
      <div class="back" @click="back">
        <i class="el-icon-arrow-left" /> 返回
      </div>
      <div class="path">
        <i class="el-icon-location" /> 首页-工地详情
      </div>
    </div>
    <div class="dusttablecont">
      <div slot="content" class="contentWrap">
        <el-tabs v-model="type" @tab-click="handleClick">
          <el-tab-pane label="全部" name="全部"></el-tab-pane>
          <el-tab-pane label="整改" name="整改类"></el-tab-pane>
          <el-tab-pane label="扣分" name="扣分类"></el-tab-pane>
          <el-tab-pane label="处罚" name="处罚类"></el-tab-pane>
        </el-tabs>
        <el-table
          :data="detailList"
          highlight-current-row
          @row-click="tableclick"
        >
          <el-table-column prop="name" label="工地名称">
            <template slot-scope="scope">
              <div class="tabletd">{{scope.row.name}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="工地地址">
            <template slot-scope="scope">
              <div class="tabletd">{{scope.row.address}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="distance" label="距离" width="120">
            <template slot-scope="scope">
              <div class="tabletd">{{(scope.row.distance/1000).toFixed(2)}}km</div>
            </template>
          </el-table-column>
          <el-table-column label="历史问题" width="260">
            <template slot-scope="scope">
              <div class="histrytable">
                <div>整改：{{scope.row.rectify}}</div>
                <div>扣分：{{scope.row.deduction}}</div>
                <div>处罚：{{scope.row.punishment}}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 50px"
          @current-change="pagechange"
          background
          page-size="12"
          layout="prev, pager, next"
          :current-page="page"
          :total="total"
        ></el-pagination>
      </div>

      <div slot="detail" class="detail">
        <div class="detailtitle">工地详情</div>
        <div class="wire" />
        <div class="detailstable">
          <div class="box">
            <div class="title">监理</div>
            <div class="value">{{detaildata.supervision ? detaildata.supervision : '-' }}</div>
          </div>

          <div class="box">
            <div class="title">甲方</div>
            <div class="value">{{detaildata.building ? detaildata.building : '-' }}</div>
          </div>

          <div class="box">
            <div class="title">乙方</div>
            <div class="value">{{detaildata.construction ? detaildata.construction : '-' }}</div>
          </div>

          <div class="box">
            <div class="title">工地名称</div>
            <div class="value">{{detaildata.name ? detaildata.name : '-' }}</div>
          </div>

          <div class="box">
            <div class="title">工地地址</div>
            <div class="value">{{detaildata.address ? detaildata.address : '-' }}</div>
          </div>

          <div class="box">
            <div class="title">信用等级</div>
            <div class="value">{{detaildata.level ? detaildata.level : '-' }}</div>
          </div>

          <div class="box" style="border-bottom: 1px solid #e2e5ec;">
            <div class="title">历史问题</div>
            <div class="values">
              <div>整改：{{single.rectify}}</div>
              <div>扣分：{{single.deduction}}</div>
              <div>处罚：{{single.punishment}}</div>
            </div>
          </div>
        </div>
        <div class="detail_item">
          <p style="font-size: 16px">扬尘问题</p>
          <div class="item">
            <div class="left">问题类型：</div>
            <div class="right">{{detaildata.mold}}</div>
          </div>
          <div class="item">
            <div class="left">问题描述：</div>
            <div class="right">{{detaildata.content ? detaildata.content : '-' }}</div>
          </div>
          <div class="item">
            <div class="left">当前状态：</div>
            <div class="right">{{detaildata.types}}</div>
          </div>
          <div class="item">
            <div class="left">督查时间：</div>
            <div class="right">{{detaildata.uptime ? detaildata.uptime : '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var BMap = window.BMap;
import { mapState } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
export default {
  data() {
    return {
      total: 0,
      page: 1,
      activeName: "first",
      latitude: "",
      longitude: "",
      detailList: [],
      type: "全部",
      detaildata: [],
      single: []
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  mounted() {
    this.location();
  },
  methods: {
    back() {
      this.$router.push({ name: "HomePage" });
      console.log(33);
    },
    handleClick(e) {
      console.log(e);
      this.type = e.name;
      this.page = 1;
      this.$nextTick(()=>{
        this.getdustdata();
      })
      
    },
    tableclick(e) {
      console.log(e);
      this.single = e;
      this.getdustdetail(e.name);
    },
    pagechange(e) {
      console.log(e);
      this.page = e;
      this.getdustdata();
    },
    async location() {
      try {
        var r = await this.getCurrentPosition();
        if (r.point) {
          this.latitude = r.point.lat;
          this.longitude = r.point.lng;
        } else {
          this.latitude = 0;
          this.longitude = 0;
        }
        this.getdustdata();
      } catch (e) {
        console.log(e);
        this.latitude = 0;
        this.longitude = 0;
        this.getdustdata();
      }
    },
    async getdustdata() {
      var param = {
        eid: this.userInfo.eid,
        page: this.page,
        size: 12,
        type: this.type,
        latitude: this.latitude,
        longitude: this.longitude
      };
      console.log(".........", param);
      try {
        const res = await getServerData(APIMAP.JSDUST, param, "get");
        console.log("列表", res);
        this.detailList = res.rows;
        this.total = res.total;
        this.single = res.rows[0];
        this.getdustdetail(res.rows[0].name);
      } catch (e) {
        console.log(e);
      }
    },
    async getdustdetail(name) {
      var param = {
        eid: this.userInfo.eid,
        name: name
      };
      console.log(param);
      try {
        const res = await getServerData(APIMAP.JSDUSTNEW, param, "get");
        console.log("列表", res);
        var types = "";
        if (res.status == 3) {
          types = "归档";
        } else if (res.status === "2") {
          types = "处理完成";
        } else if (res.status === "1") {
          types = "审核待处理";
        } else if (res.status === "0") {
          types = "上传待审核";
        } else if (res.status === "-2") {
          types = "驳回待上传";
        } else if (res.status === "-3") {
          types = "申诉";
        } else {
          types = "-";
        }

        var mold = "";
        if (res.type === "1") {
          mold = "一般问题";
        } else if (res.type === "2") {
          mold = "严重问题";
        } else if (res.type === "3") {
          mold = "特别严重";
        } else {
          mold = "无";
        }
        res.mold = mold;
        res.types = types;
        this.detaildata = res;
      } catch (e) {
        console.log(e);
      }
    },
    getCurrentPosition() {
      var geolocation = new BMap.Geolocation();
      return new Promise(resolve => {
        geolocation.getCurrentPosition(r => {
          console.log(111, r);
          resolve(r);
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.dustcont {
  background-color: #f5f6fd;
  padding: 17px 19px;
  height: calc(100vh - 100px);
  width: 100%;
  box-sizing: border-box;

  .top {
    height: 49px;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #99a9ba;
    overflow: hidden;
    position: relative;
    background: white;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    .back {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
      cursor: pointer;
    }
    .path {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
    }
  }
  .dusttablecont {
    margin-top: 9px;
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    overflow: hidden;
    position: relative;
    .contentWrap {
      float: left;
      width: calc(100% - 470px);
      height: calc(100vh - 195px);
      background: white;
      padding: 20px 15px;
      border-radius: 4px;
      box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
      .tabletd {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .histrytable {
        display: flex;
        justify-content: space-between;
      }
    }
    .detail {
      float: right;
      width: 400px;
      height: calc(100vh - 195px);
      background: white;
      padding: 20px 15px;
      border-radius: 4px;
      box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
      .detailtitle {
        font-size: 14px;
        font-weight: 600;
        text-align: left;
      }
      .wire {
        margin-top: 18px;
        margin-bottom: 18px;
        border-bottom: 1px solid rgba(226, 229, 236, 0.6);
      }
      .detailstable {
        .box {
          border: 1px solid #e2e5ec;
          border-radius: 4px;
          overflow: hidden;
          border-bottom: 0px;
          .title {
            float: left;
            width: 100px;
            font-size: 14px;
            padding: 10px 10px;
            border-right: 1px solid #e2e5ec;
          }
          .value {
            float: left;
            width: 238px;
            font-size: 14px;
            padding: 10px 10px;
          }
          .values {
            float: left;
            width: 238px;
            font-size: 14px;
            padding: 10px 10px;
            display: flex;
            justify-content: space-between;
          }
        }
      }
      .detail_item {
        font-size: 14px;
        margin-top: 20px;
        padding: 15px;
        background: #f8fafb;
        float: left;
        width: calc(100% - 30px);
        .item {
          margin: 10px 0;
          width: 100%;
          float: left;
          div {
            float: left;
          }
          .left {
            width: 30%;
            color: #707b86;
          }
          .right {
            width: 70%;
          }
        }
      }
    }
  }
}

// .top {
//   background: white;
//   font-size: 14px;
//   font-family: PingFangSC, PingFangSC-Regular;
//   color: #99a9ba;
//   overflow: hidden;
//   position: relative;
//   border-radius: 4px;
//   line-height: 50px;
//   width: calc(100% - 52px);
//   margin: 20px auto 0 auto;
//   .back {
//     display: inline-block;
//     cursor: pointer;
//   }
//   .path {
//     margin-left: 19px;
//     display: inline-block;
//   }
// }
// .dustcont {
//   height: calc(100vh - 250px);
//   .tabletd {
//     width: 100%;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: nowrap;
//   }
//   .histrytable {
//     display: flex;
//     justify-content: space-between;
//   }
// }
// .contentWrap {
//   .tr {
//     background: #f7fafd;
//   }
// }
// .detail {
//   .detail_item {
//     font-size: 14px;
//     margin-top: 20px;
//     padding: 15px;
//     background: #f8fafb;
//     float: left;
//     width: calc(100% - 30px);
//     .item {
//       margin: 10px 0;
//       width: 100%;
//       float: left;
//       div {
//         float: left;
//       }
//       .left {
//         width: 30%;
//         color: #707b86;
//       }
//       .right {
//         width: 70%;
//       }
//     }
//   }
// }
</style>